/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum HistoricalInformationSourceType {
  BOOK = 'Book',
  EDITED_BOOK_SECTION = 'EditedBookSection',
  JOURNAL = 'Journal',
  MANUSCRIPT = 'Manuscript',
  ORAL = 'Oral',
  MAP = 'Map',
  NEWSPAPER = 'Newspaper',
  ARTEFACT = 'Artefact',
  WEBSITE = 'Website',
  COUNCIL = 'Council',
  OGN = 'OGN',
}
